export default __webpack_public_path__ + "static/media/pizza-hero.e4861efd.jpg";